import { useRecordContext, ReferenceField, TextField, type RaRecord } from "react-admin";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { formatListDate } from "@/utils/date-format";
import RazaRequestProgressChecklist from "./RazaRequestProgressChecklist";

export const RazaRequestShowHeader = () => {
  const record = useRecordContext<RaRecord>();
  if (!record) return null;
  const granted = Boolean(record.razaGranted);
  return (
    <Box
      sx={{
        px: 2,
        pt: 2,
        pb: 1.5,
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h6" component="h2" noWrap>
            {typeof record.name === "string" && record.name.trim()
              ? record.name.trim()
              : "Raza request"}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ mt: 0.5 }}>
            <Typography variant="body2" color="text.secondary">
              ITS {typeof record.itsNo === "string" ? record.itsNo : "—"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              ·
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Mohallah{" "}
              {typeof record.mohallah === "string" && record.mohallah.trim()
                ? record.mohallah
                : "—"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              ·
            </Typography>
            {typeof record.purposeName === "string" && record.purposeName.trim() ? (
              <Typography variant="body2" color="text.secondary">
                {record.purposeName.trim()}
              </Typography>
            ) : (
              <ReferenceField source="purpose" reference="bookingPurpose" link={false}>
                <TextField source="name" />
              </ReferenceField>
            )}
          </Stack>
        </Box>
        <Box sx={{ textAlign: { xs: "left", sm: "right" } }}>
          <Chip
            size="small"
            label={granted ? "Raza granted" : "Raza pending"}
            color={granted ? "success" : "warning"}
            variant={granted ? "filled" : "outlined"}
          />
          {granted ? (
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
              {formatListDate(record.razaGranted as string | Date, { empty: "" })}
            </Typography>
          ) : null}
        </Box>
      </Stack>
      <RazaRequestProgressChecklist />
    </Box>
  );
};
